import { Button, Flex, HStack, IconButton, Select, Text, useColorModeValue } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

const PAGE_SIZE_OPTIONS = [5, 10, 20, 50];

interface WhitelistPaginationProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalFiltered: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

export const WhitelistPagination = ({
  currentPage, totalPages, pageSize, totalFiltered, onPageChange, onPageSizeChange,
}: WhitelistPaginationProps) => {
  const borderColor = useColorModeValue("gray.100", "whiteAlpha.100");
  const labelColor  = useColorModeValue("gray.500", "gray.400");
  const sectionBg   = useColorModeValue("gray.50", "#0a1628");
  const pageBtnBg   = useColorModeValue("white", "#0f2040");

  return (
    <Flex
      align="center" justify="space-between" px={5} py={3}
      borderTop="1px solid" borderColor={borderColor}
      bg={sectionBg} flexWrap="wrap" gap={2}
    >
      <HStack spacing={2}>
        <Text fontSize="xs" color={labelColor}>Linhas por página:</Text>
        <Select
          size="xs" value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          bg={pageBtnBg} borderRadius="md" w="64px" fontSize="xs"
        >
          {PAGE_SIZE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
        </Select>
        <Text fontSize="xs" color={labelColor}>
          {((currentPage - 1) * pageSize) + 1}–{Math.min(currentPage * pageSize, totalFiltered)} de {totalFiltered}
        </Text>
      </HStack>

      {totalPages > 1 && (
        <HStack spacing={1}>
          <IconButton
            aria-label="Página anterior" icon={<ChevronLeftIcon boxSize={4} />}
            size="xs" variant="outline" borderRadius="md" bg={pageBtnBg}
            isDisabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)}
          />
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <Button
              key={page} size="xs" borderRadius="md" minW="28px"
              variant={page === currentPage ? "solid" : "outline"}
              colorScheme={page === currentPage ? "blue" : "gray"}
              bg={page === currentPage ? undefined : pageBtnBg}
              fontWeight={page === currentPage ? 700 : 400}
              onClick={() => onPageChange(page)}
            >
              {page}
            </Button>
          ))}
          <IconButton
            aria-label="Próxima página" icon={<ChevronRightIcon boxSize={4} />}
            size="xs" variant="outline" borderRadius="md" bg={pageBtnBg}
            isDisabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)}
          />
        </HStack>
      )}
    </Flex>
  );
};
